<template>
    <header class="container">
        <nav class="navbar primary-nav">
            <div class="container-fluid">
                <a class="navbar-brand" href="/">
                    <img class="logo" src="/img/djmonitor_all_black.png" alt="DJMonitor" width="100">
                </a>

                <div class="d-flex" @click="toggleTheme">
                    <transition name="fade" mode="out-in">
                        <i v-if="theme == 'dark'" class="fas fa-sun"></i>
                        <i v-else class="fas fa-moon"></i>
                    </transition>
                </div>
            </div>
        </nav>

        <nav class="navbar device-nav" v-if="GoConnect.device.name !== '' && route.meta.mode !== 'setup'">
            <div class="container-fluid">
                <h3>
                    <i class="fab fa-bluetooth-b"></i>
                    {{ GoConnect.device.name }}
                </h3>
                <ul class="nav">
                    <!--<li class="nav-item" v-if="GoConnect.device.name >= 'GO00500'">
                        <button class="btn">
                            <i v-if="GoConnect.device.hasACPower" class="fas fa-plug"></i>
                            <i v-else-if="GoConnect.device.batteryLevel >= 90" class="fas fa-battery-full"></i>
                            <i v-else-if="GoConnect.device.batteryLevel >= 62.5" class="fas fa-battery-three-quarters"></i>
                            <i v-else-if="GoConnect.device.batteryLevel >= 37.5" class="fas fa-battery-half"></i>
                            <i v-else-if="GoConnect.device.batteryLevel >= 12.5" class="fas fa-battery-quarter"></i>
                            <i v-else class="fas fa-battery-empty"></i>
                        </button>
                    </li>-->

                    <li class="nav-item">
                        <router-link class="btn btn-outline-dark" to="/device/audio">
                            <i v-if="getVolume() >= -30" class="fas fa-volume-up fa-fw"
                                style="margin-right: 0.5rem; text-align:left"></i>
                            <i v-else-if="getVolume() >= -50" class="fas fa-volume-down fa-fw"
                                style="margin-right: 0.5rem; text-align:left"></i>
                            <i v-else class="fas fa-volume-off fa-fw" style="margin-right: 0.5rem; text-align:left"></i>
                            Audio
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="btn btn-outline-dark" to="/device/network">
                            <i class="fas fa-wifi"></i>
                            Network
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="btn btn-outline-dark" to="/device/dmc">
                            DMC
                        </router-link>
                    </li>

                    <li class="nav-item">
                        <button class="btn btn-outline-dark" @click="GoConnect.disconnect()">
                            <i class="fas fa-unlink"></i>
                        </button>
                    </li>
                    
                    <li class="nav-item" v-if="GoConnect.device.name >= 'GO00500'">
                        <button class="btn btn-outline-dark" data-bs-toggle="modal" data-bs-target="#shutdownModal">
                            <i class="fas fa-power-off"></i>
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    </header>

    <div class=" container">
        <section>
            <AlertBox />
        </section>
    </div>

    <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
            <component :is="Component" />
        </transition>
    </router-view>

    <div class="modal fade" id="shutdownModal" tabindex="-1" aria-labelledby="shutdownModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="shutdownModalLabel">Shutdown {{ GoConnect.device.name }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="alert alert-danger" role="alert">
                        <i class="fas fa-exclamation-triangle"></i>
                        This will power down {{ GoConnect.device.name }}, to start up the device again you will need to press the physical hardware button on the front.
                    </div>
                </div>

                <div class="modal-footer">
                    <div class="row w-100">
                        <div class="col-6">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                                Cancel
                            </button>
                        </div>
                        <div class="col-6">
                            <button type="button" class="btn btn-danger" @click="shutdown()">
                                <i class="fas fa-power-off"></i> 
                                Confirm Shutdown
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {
    inject, ref, watch, onMounted,
} from 'vue';
import { Modal } from 'bootstrap';
import { useRoute } from 'vue-router';

import AlertBox from './components/AlertBox.vue';

const route = useRoute();
const GoConnect = inject('GoConnect');

const theme = ref('light');

/**
 * @todo store theme in localStorage
 */
function toggleTheme() {
    if (theme.value === 'dark') {
        theme.value = 'light';
    } else {
        theme.value = 'dark';
    }
}

function getVolume() {
    return (GoConnect.vu.left + GoConnect.vu.right) / 2;
}

function shutdown() {
    GoConnect.shutdown();

    const element = document.getElementById('shutdownModal');
    const shutdownModal = Modal.getInstance(element);
    shutdownModal.hide();
}

onMounted(() => {
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        theme.value = 'dark';
    }

    if (navigator.bluetooth === undefined) {
        GoConnect.handleError('error', 'Your browser is not supported');
    }
});

watch(theme, async (newTheme) => {
    document.documentElement.setAttribute('data-bs-theme', newTheme);
});
</script>
